import { UpLog } from '../uplus-api/modules/uplog';
import { NebulaUpLogPlugin } from '../nebula-class/plugins/nebula-uplog-plugin';
import './upAppinfoModule';
import upStorageModule from './upStorageModule';
UpLog.getDevModeState(upStorageModule);
export default new UpLog(new NebulaUpLogPlugin());